"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderReminders = void 0;
const factories_1 = require("../../factories");
const getOrderReminders = (order_id, supabase) => {
    factories_1.OrderRequestFactory.getOrderRemindersByOrderId(supabase, order_id).then((res) => {
        if (res === undefined) {
            return res;
        }
        else {
            return res;
        }
    });
};
exports.getOrderReminders = getOrderReminders;
